import "./assets/scss/main.scss"
import LazyLoad from "react-lazyload"
import { Booklet } from "./components/booklet"
import { bookletsNarratifs, bookletsInformatifs } from "./data/booklets"

function App() {
	return (
		<>
			<header>
				<div className="container">
					<div className="row justify-content-between align-items-end">
						<div className="col-12 col-md-12 col-lg-7 col-xl-6">
							<div className="row">
								<div className="col">
									<h1>
										<span className="title-bigger">
											Livrets de la collection&nbsp;GB+
										</span>{" "}
										en langue des signes québécoise&nbsp;(LSQ)
									</h1>
								</div>
								<div className="d-none d-md-block d-lg-none col-md-5 mx-auto text-end header__fox">
									<img
										src={
											process.env.PUBLIC_URL + `/images/layout/header-fox.svg`
										}
										alt=""
									/>
								</div>
							</div>
							<p>
								Sous format vidéo, les livrets traduits et adaptés à la langue
								des signes québécoise (LSQ) visent le développement d’habiletés
								en lecture d’élèves de la 1<sup>re</sup> à la 3<sup>e</sup>{" "}
								année ayant une surdité ou une malentendance. Engageantes et
								conviviales, ces vidéos utilisent le vocabulaire et la
								terminologie qui s’alignent avec le curriculum de l’Ontario et
								de la LSQ d’usage dans les écoles de langue française de la
								province. La collection GB+ propose des textes narratifs et
								informatifs nivelés qui portent sur une multitude de thèmes
								stimulants.
							</p>
						</div>
						<div className="col-8 col-lg-5 colxl-6 d-md-none d-lg-block mx-auto mx-lg-0 text-end header__fox">
							<img
								src={process.env.PUBLIC_URL + `/images/layout/header-fox.svg`}
								alt=""
							/>
						</div>
					</div>
				</div>
			</header>

			<main className="container booklets">
				<section id="booklets-narrative" className="booklets__section">
					<h2>
						Livrets <span className="title-bigger">narratifs</span>
					</h2>

					<ul className="list-unstyled list-booklets">
						{bookletsNarratifs.map((props, idx) => (
							<Booklet key={idx} {...props} />
						))}
					</ul>
				</section>

				<section id="booklets-informative" className="booklets__section">
					<h2>
						Livrets <span className="title-bigger">informatifs</span>
					</h2>

					<ul className="list-unstyled list-booklets">
						{bookletsInformatifs.map((props, idx) => (
							<Booklet key={idx} {...props} />
						))}
					</ul>
				</section>
			</main>

			<footer>
				<div className="container footer__title">
					<h2>Crédits</h2>
				</div>
				<div className="footer__content">
					<div className="container">
						<div className="row">
							<div className="col">
								<p>© 2022 TC Média Livres Inc.</p>
							</div>
						</div>
						<div className="row gx-lg-5">
							<div className="col-12 col-lg-6">
								<p>
									Ce projet a été rendu possible grâce à la contribution
									financière du ministère de&nbsp;l’Éducation de&nbsp;l’Ontario
									et du&nbsp;gouvernement du&nbsp;Canada dans le&nbsp;cadre
									de&nbsp;l’Entente Canada-Ontario relative
									à&nbsp;l’enseignement dans la&nbsp;langue de la&nbsp;minorité
									et à&nbsp;l’enseignement de la&nbsp;seconde langue officielle.
								</p>
								<p>
									À noter que le contenu n’engage que ses auteurs et ne traduit
									pas nécessairement le&nbsp;point de&nbsp;vue du&nbsp;ministère
									de&nbsp;l’Éducation de&nbsp;l’Ontario
									ou&nbsp;du&nbsp;gouvernement du&nbsp;Canada.
								</p>
							</div>
							<div className="col-12 col-lg-6">
								<p>
									<strong>Conception graphique et infographie&nbsp;:</strong>
									<br />
									Pige communication
								</p>
								<p>
									<strong>Gestionnaire de projet&nbsp;:</strong>
									<br />
									Cinéall
								</p>
								<p>
									<strong>
										Point de contact et responsable du contrôle de la
										qualité&nbsp;:
									</strong>
									<br />
									Services linguistiques CB
								</p>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<ul className="footer__logos">
									<li>
										<LazyLoad height={50}>
											<img
												src={
													process.env.PUBLIC_URL +
													`/images/logos/CheneliereEducation.svg`
												}
												width="116"
												height="50"
												alt="Logo de Chenelière Éducation"
											/>
										</LazyLoad>
									</li>
									<li>
										<LazyLoad height={50}>
											<img
												src={
													process.env.PUBLIC_URL + `/images/logos/Ontario.svg`
												}
												width="198"
												height="50"
												alt="Logo du Gouvernement de l’Ontario"
											/>
										</LazyLoad>
									</li>
									<li>
										<LazyLoad height={60}>
											<img
												src={
													process.env.PUBLIC_URL + `/images/logos/Canada.svg`
												}
												width="169"
												height="40"
												alt="Logo du Gouvernement du Canada"
											/>
										</LazyLoad>
									</li>
									<li>
										<LazyLoad height={60}>
											<img
												src={
													process.env.PUBLIC_URL + `/images/logos/Cineall.png`
												}
												width="54"
												height="50"
												alt="Logo de Cinéall"
											/>
										</LazyLoad>
									</li>
									<li>
										<LazyLoad height={60}>
											<img
												src={process.env.PUBLIC_URL + `/images/logos/SLCB.png`}
												width="178"
												height="50"
												alt="Logo des Services linguistiques CB"
											/>
										</LazyLoad>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</>
	)
}

export default App
